import React from 'react';
import { TextField } from '@material-ui/core';

export const BaseTextField = ({
	title,
	name,
	error,
	onChange,
	value,
	type,
	multiline,
	rows,
}) => {
	return (
		<TextField
			fullWidth
			label={title}
			error={error}
			margin='dense'
			name={name}
			onChange={onChange}
			required
			value={value}
			variant='outlined'
			type={type}
			multiline={multiline}
			rows={rows}
		/>
	);
};

export default BaseTextField;
